import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, FileText } from 'lucide-react';
import { issueService } from '../services/api';

function Archive() {
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(true);

  React.useEffect(() => {
    const fetchIssues = async () => {
      try {
        const response = await issueService.getAll();
        setIssues(response.data);
      } catch (error) {
        console.error('Error fetching issues:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchIssues();
  }, []);

  const groupedByYear = {};
  issues.forEach(issue => {
    const year = new Date(issue.publicationDate).getFullYear();
    if (!groupedByYear[year]) {
      groupedByYear[year] = [];
    }
    groupedByYear[year].push(issue);
  });

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">آرشیو</h1>
          <p className="text-xl text-blue-100">تمام شماره‌های منتشر شده</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 py-16">
        {loading ? (
          <div className="text-center py-12 text-gray-500">در حال بارگذاری...</div>
        ) : (
          <div className="space-y-12">
            {Object.entries(groupedByYear)
              .sort(([yearA], [yearB]) => parseInt(yearB) - parseInt(yearA))
              .map(([year, yearIssues]) => (
                <div key={year}>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6 pb-4 border-b-2 border-blue-700">
                    سال {year}
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {yearIssues.map((issue) => (
                      <Link
                        key={issue.id}
                        to={`/issues/${issue.id}`}
                        className="bg-white rounded-lg shadow-md hover:shadow-lg transition overflow-hidden group"
                      >
                        <div className="bg-gradient-to-br from-blue-700 to-blue-900 text-white p-6 group-hover:from-blue-800 group-hover:to-blue-950 transition">
                          <div className="text-4xl font-bold mb-2 text-blue-100">{issue.volume}</div>
                          <p className="text-blue-200">جلد {issue.volume} - شماره {issue.number}</p>
                        </div>
                        <div className="p-6">
                          <h3 className="font-bold text-gray-900 mb-3 group-hover:text-blue-700 transition">{issue.title}</h3>
                          <div className="flex items-center justify-between text-sm text-gray-500 pt-4 border-t border-gray-200">
                            <span className="flex items-center gap-2">
                              <FileText size={16} className="text-blue-600" />
                              {issue.articles?.length || 0} مقاله
                            </span>
                            <span className="flex items-center gap-2">
                              <Calendar size={16} className="text-blue-600" />
                              {new Date(issue.publicationDate).toLocaleDateString('fa-IR')}
                            </span>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Archive;
